import { REQUEST_S_C} from '../../const';

export default function SCReducer(state = [], action) {
  switch (action.type) {
      case REQUEST_S_C:
      return action.s_c;
    default:
      return state;
  }
}